var _ellipse, _ellipse2, _path, _path2, _path3, _path4, _rect, _g, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgentUnavailable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51,
    cy: 51,
    rx: 51,
    ry: 51,
    strokeWidth: 0,
    transform: "rotate(-180 51 51)",
    fill: "url(#paint0_linear_13539_57603)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    cx: 50.9998,
    cy: 35.5814,
    rx: 18.9767,
    ry: 18.9767,
    strokeWidth: 0,
    transform: "rotate(-180 50.9998 35.5814)",
    fill: "url(#paint1_linear_13539_57603)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 32C27 20.9543 37.1929 11.5 51 11.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73 29C73 19.6112 63.6565 11.5 51 11.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30C73 39.3888 63.6565 47 51 47",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.3089 83.4949C80.9544 94.7982 66.8181 102 50.9998 102C35.1814 102 21.0449 94.7981 11.6904 83.4946C19.4139 69.7637 34.1236 60.4883 50.9996 60.4883C67.8758 60.4883 82.5855 69.7638 90.3089 83.4949Z",
    strokeWidth: 0,
    fill: "url(#paint2_linear_13539_57603)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 65,
    width: 40,
    height: 40,
    rx: 20,
    strokeWidth: 0,
    fill: "#4F6291"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13539_57603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.9 86.0916C84.7457 86.938 85.7015 87.6668 86.7417 88.2583L87.8 87.1999C88.0266 86.9759 88.3126 86.8215 88.6243 86.755C88.9359 86.6885 89.26 86.7128 89.5583 86.8249C90.3144 87.107 91.0999 87.3027 91.9 87.4083C92.3004 87.4649 92.6667 87.6651 92.9304 87.9718C93.1941 88.2784 93.3373 88.6705 93.3333 89.0749V91.5749C93.3343 91.807 93.2867 92.0367 93.1937 92.2494C93.1008 92.462 92.9644 92.6529 92.7934 92.8098C92.6224 92.9667 92.4205 93.0862 92.2006 93.1605C91.9808 93.2349 91.7478 93.2625 91.5167 93.2416C88.9523 92.963 86.4892 92.0867 84.325 90.6833C83.321 90.0458 82.3904 89.2996 81.55 88.4583M79.325 85.6749C77.9215 83.5108 77.0453 81.0476 76.7667 78.4833C76.7458 78.2528 76.7732 78.0206 76.8471 77.8013C76.9209 77.582 77.0396 77.3805 77.1956 77.2096C77.3516 77.0387 77.5415 76.9022 77.7531 76.8087C77.9648 76.7152 78.1936 76.6668 78.425 76.6666H80.925C81.3294 76.6626 81.7215 76.8058 82.0281 77.0695C82.3348 77.3332 82.535 77.6995 82.5917 78.0999C82.6972 78.9 82.8929 79.6855 83.175 80.4416C83.2871 80.7399 83.3114 81.064 83.2449 81.3757C83.1784 81.6873 83.024 81.9733 82.8 82.1999L81.7417 83.2583",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1667 75.8333L75.8334 94.1666",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 46,
    r: 5,
    strokeWidth: 0,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13539_57603",
    x1: 18,
    y1: 9.00002,
    x2: 150,
    y2: 164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13539_57603",
    x1: 61.9996,
    y1: 51.6627,
    x2: 42.4996,
    y2: 18.1627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13539_57603",
    x1: 22,
    y1: 40,
    x2: 50.9997,
    y2: 102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E7EE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13539_57603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(75 75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentUnavailable);
export default __webpack_public_path__ + "static/media/agent-unavailable.94932aaf0f84d662af7a6f3d58b9ad28.svg";
export { ForwardRef as ReactComponent };